import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Chart from 'chart.js';

class RegistrationsCharts extends React.PureComponent {
    constructor(props) {
        super(props);

        const { statisticsUsers, searchText } = props;

        this.state = {
            statisticsUsers: this.filterSearch(statisticsUsers, searchText),
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates();
    }

    filterSearch(items, searchText) {
        return items.filter((item) => {
            if (item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (item.surname && item.surname.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (item.email && item.email.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (_.has(item, 'item.company.name') && item.company.name.toLowerCase().includes(searchText.toLowerCase())) {
                return true;
            }

            if (_.has(item, 'item.phones[0].phone') && item.phones[0].phone.toLowerCase().includes(searchText.toLowerCase())) {
                    return true;
            }

            return false;
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { statisticsUsers, searchText } = nextProps;

        if (!statisticsUsers.length) {
            return;
        }

        this.setState({
            statisticsUsers: this.filterSearch(statisticsUsers, searchText),
        }, () => {
            this.createRangeDates();
        });
    }

    createRangeDates() {
        let { statisticsUsers, chart } = this.state;
        const { from, until } = this.props;

        const countOfDays = moment(until).startOf('day').diff(moment(from).startOf('day'), 'days');

        const rangeDates = {};

        const labels = [];
        const verified = [];
        const visited = [];
        const registered = [];

        for (let i = 0; i <= countOfDays; i++) {
            rangeDates[moment(from).add(i, 'days').format('MM-DD-YYYY')] = {
                date: moment(from).add(i, 'days'),
                verified: 0,
                visited: 0,
                registered: 0,
            };
        }

        statisticsUsers.forEach((user) => {
            const date = rangeDates[moment(user.createdAt).startOf('day').utcOffset(0, true).format('MM-DD-YYYY')];

            if (!date) {
                return;
            }

            date.registered += 1;

            if (user.password) {
                date.visited += 1;
            }

            if (user.emailVerified) {
                date.verified += 1;
            }
        });

        for (let key in rangeDates) {
            labels.push(moment(rangeDates[key].date).format('DD-MM'));
            verified.push(rangeDates[key].verified);
            visited.push(rangeDates[key].visited);
            registered.push(rangeDates[key].registered);
        }

        const datasets = [{
            label: 'Verified email',
            backgroundColor: '#ffa',
            borderColor: '#ffa',
            data: verified,
        }, {
            label: 'Visited site',
            backgroundColor: '#faf',
            borderColor: '#faf',
            data: visited,
        }, {
            label: 'registered on site',
            backgroundColor: '#aff',
            borderColor: '#aff',
            data: registered,
        }];

        if (_.isEmpty(chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chart.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return chart;
    }

    render() {
        return (
            <div className='row'>
                <div className='col-xs-12'>
                    <canvas ref='chart' />
                </div>
            </div>
        );
    }
}

export default connect(
    ({ statisticsUsers: { items, searchText } }, { from, until }) => {
        return {
            statisticsUsers: items,
            searchText,
            from,
            until,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(RegistrationsCharts);



// WEBPACK FOOTER //
// ./app/components/Statistics/Users/RegistrationsCharts.jsx